export const DbDateFormat = 'YYYY-MM-DD';
export const AppDateFormat = 'Do MMM YYYY';
